var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{staticClass:"nav",attrs:{"src":require("./assets/nav.png"),"alt":""},on:{"click":_vm.ChangenavShow}}),_c('Nav'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }